import { render, staticRenderFns } from "./AbnormalRecord.vue?vue&type=template&id=afd4b27a&"
import script from "./AbnormalRecord.vue?vue&type=script&lang=js&"
export * from "./AbnormalRecord.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalRecord.vue?vue&type=style&index=0&id=afd4b27a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports